
import {map} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { RestService } from '../providers/rest.service';
import { ICityInput } from '../../shared/models/CityInputModel';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
import { IResponseModel } from '../../shared/models/ResponseModel';
import { INoteInput } from '../../shared/models/NotesInputModel';
import { INotes } from '../../shared/models/NotesListOutModel';
import { DuplicateEmailCheckInputModel } from '../../shared/models/DuplicateEmailCheckInputModel';
import { IMessageInput, MessageSearchInputModel, MessageFollowInputModel } from '../../shared/models/MessageInputModel';
import { OMessageOutput } from '../../shared/models/MessageOutputModel';
import { IMessageGroupInputModel } from '../../shared/models/MessageGroupInputModel';
import { MessageGroupCreateInputModel } from '../../shared/models/MessageGroupCreateInputModel';
import { MessageUserListInputModel } from '../../shared/models/MessageUserListInputModel';
import { MessageUserListOutModel } from '../../shared/models/MessageUserListOutputModel';
import { AuditTrailLogListModel } from '../../shared/models/AuditTrailLogListModel';
import { AuditTrailDetailModel } from '../../shared/models/AuditTrailDetailModel';
import { AllReceivedMessageInputModel } from '../../shared/models/AllReceivedMessageInputModel';
import { IFeaturedNewsInput } from '../../shared/models/FeaturedNewsInputModel';
import { ITypeInput } from '../../shared/models/ITypeInput';
import { ITypeSubcategoryInput } from '../../shared/models/ITypeSubcategoryInput';
import { NewsTickerDetailsModel } from '../models/NewsTickerDetailsModel';
import { IMessageGroupMemberInputModel } from '../models/MessageGroupMemberInputModel';
import * as moment from 'moment';
import { IIntercomConfig } from '../models/IntercomModel';
import { HttpHeaders } from '@angular/common/http';
import { AuditLogCategoryModel } from '../models/AuditLogCategoryModel';
import { FileCategorySave } from '../models/FileCategorySaveModel';
import { IPropertyAuditLogFilter, IPropertyData, IPropertyListOutputModel } from '../models/PropertyData';
import { IInsights } from '../models/Insights';
import { IHourModel } from '../../data-entry-dashboard/data-entry-dashboard/data-entry-dashboard.component';
import { IMarketDataInputModel } from '../models/MarketDataInputModel';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends RestService {

  // Gets the list of states
  getStateList() {
    return this.GET('common/states');
  }

  // Gets the list of cities
  getCitiesList(stateId: number) {
    return this.GET('common/cities/' + stateId);
  }
  getCitiesListOfStates(stateId) {
    return this.GET('common/getCitiesListOfStates/' + stateId);
  }

  // Get User Roles List other than principal and 1031
  getUserRolesListForUserEntry() {
    return this.GET('common/UserRolesForUserEntry');
  }

  // Get all User Roles List 
  getUserRolesList() {
    return this.GET('common/UserRoles');
  }

  // Get all User Roles List 
  getUserRolesListForPermissions() {
    return this.GET('common/UserRolesForPermissions');
  }

  getUserRole(userId: number) {

    return this.GET('common/UserRole/' + userId);
  }

  // Gets the list of lookups by type id
  GetOfferStatus(typeId: number) {
    return this.GET('common/GetOfferStatus/' + typeId);
  }

  // Gets the list of lookups by type id
  getLookupsByTypeId(typeId: number) {
    return this.GET('common/lookups/' + typeId);
  }

  // Gets the list of lookups by type id
  getProspectStatus() {
    return this.GET('common/prospectstatus');
  }

  getMetaTags(typeId) {
    return this.post('common/getmetaTags', typeId);
  }

  getPropertyRevisionFieldLogicData(revisionFieldId: number) {
    return this.GET('property/getPropertyRevisionFieldLogicData/' + revisionFieldId);
  }

  getPropertIds(userRole: number, userId: number, otherUserId: number, messageGroupId: number, searchText: string) {
    searchText = searchText.replace("#", "");
    return this.GET('common/PropertyIds?searchText=' + searchText + '&roleId=' + userRole + '&userId=' + userId + '&otherUserId=' + otherUserId + '&messageGroupId=' + messageGroupId);
  }

  getUnreadMessageCount(userId: number) {
    return this.GET('common/getUnreadMessageCount?userId=' + userId);
  }

  getSelecetedUserHourLimit(userId: number) {
    return this.GET('common/HourLimit?userId=' + userId);
  }

  getNotification(data: any) {
    let url = "common/getNotificationForHeader/";
    return this.postForEntityObject(url, data).pipe(
      map(response => {
        return response;
      }));
  }

  readNotification(data: any) {
    let url = "common/readNotification/";
    return this.postForEntityObject<boolean>(url, data).pipe(
      map(response => {
        return response;
      }));
  }

  deleteNotification(id: number, userId: number) {
    return this.GET('common/deletetNotification?userId=' + userId + '&id=' + id);
  }

  addUTMCodesToActivityLog(data: any) {
    let url = "common/UtmCodeToActivityLog/";
    return this.postForEntityObject<boolean>(url, data).pipe(
      map(response => {
        return response;
      }));
  }

  clearNotification(data: any) {
    let url = "common/clearNotification/";
    return this.postForEntityObject<boolean>(url, data).pipe(
      map(response => {
        return response;
      }));
  }

  // Gets the list of sub category
  getPropertyStatus() {
    return this.GET('common/propertyStatuses');
  }
  // Gets the list of sub category
  getPortfolioPropertyStatus(propertyId:string,source:string) {
    return this.GET('common/PortfolioPropertyStatus/' + propertyId + "/" + source);
  }
  // Gets the list of sub category
  getSubCategories() {
    return this.GET('common/subcategories');
  }

  getBrokersNames() {
    return this.GET('common/brokers')
  }
  // Gets the video id from vimeo url
  getIdFromUrl(url: string) {
    return this._http.get('https://vimeo.com/api/oembed.json?url=' + url);
  }

  // Get User Roles List with filter
  GetUserRolesWithFilter() {
    return this.GET('common/GetUserRolesWithFilter');
  }

  // Gets the list of Compliance Broker
  GetComplianceBroker() {
    return this.GET('common/GetComplianceBroker');
  }

  // Gets the Get News Ticker Details
  GetNewsTickerDetails(ticker, typeId): Observable<NewsTickerDetailsModel> {
    return this.get('common/getNewsTickerDetails/' + ticker + "/" + typeId);
  }

  // Gets the Categories and subcategories for audti trail 
  GetCategories(isPrincipal = false): Observable<AuditLogCategoryModel[]> {
    return this.get('common/Categories/' + isPrincipal);
  }


  responseModel = {} as IResponseModel;
  resultOutputModel = {} as ResultOutputModel;

  // create new user
  saveCity(iCityInput: ICityInput) {

    let url = "/common/savecity/";
    return this.postForEntityObject<IResponseModel>(url, iCityInput).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }

  saveDealTeamContactType(iContactTypeInput) {

    let url = "/common/adddealcontacttype/";
    return this.postForEntityObject<IResponseModel>(url, iContactTypeInput).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }

  // Get get 180 Days List
  get180DaysList() {
    return this.GET('common/get180Days');
  }

  getAllPages(typeId: number) {
    return this.GET('common/Pages/' + typeId);
  }

  deleteDealTeamContactType(id: number, userId: number) {
    return this.GET('common/deletedealcontacttype?id=' + id + "&userId=" + userId);
  }

  //Delete Notes
  DeleteNote(iNoteInput: INoteInput) {
    let url = "/common/deletenote/";
    return this.postForEntityObject<boolean>(url, iNoteInput).pipe(
      map(response => {
        return response;
      }));
  }

  //SAve Notes
  SaveNote(iNoteInput: INoteInput) {
    let url = "/common/saveNote/";
    return this.postForEntityObject<IResponseModel>(url, iNoteInput).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }

  //Save news
  createNews(featuredNewsInput: IFeaturedNewsInput) {
    let url = "/common/createNews/";
    return this.postForEntityObject<ResultOutputModel>(url, featuredNewsInput).pipe(
      map(response => {
        this.resultOutputModel = response;
        return this.resultOutputModel;
      }));
  }

  //Save news
  updateNews(featuredNewsInput: IFeaturedNewsInput) {
    let url = "/common/updateNews/";
    return this.postForEntityObject<ResultOutputModel>(url, featuredNewsInput).pipe(
      map(response => {
        this.resultOutputModel = response;
        return this.resultOutputModel;
      }));
  }
  //Delete News
  deleteFeaturedNews(featuredNewsId: number) {
    let url = "common/deleteFeaturedNews/" + featuredNewsId;
    return this.post(url, '');
  }

  setNewsToPublish(id: number, status: boolean) {
    return this.GET('common/setNewsToPublish/' + id + "/" + status);
  }

  setAsFeaturedNews(id: number, status: boolean) {
    return this.GET('common/setAsFeaturedNews/' + id + "/" + status);
  }
  // Gets the list of notes 
  getNotesList(iNoteInput: INoteInput): Observable<INotes[]> {
    return this.postForEntityObject('common/notes/', iNoteInput);
  }

  // Gets the list of states
  IsOfferPlaced(guid, userId) {
    return this.get('property/IsOfferPlaced/' + guid + "/" + userId);
  }

  // check Duplicate Email 
  checkDuplicateEmail(duplicateEmailCheckInputModel: DuplicateEmailCheckInputModel) {
    return this.postForEntityObject('common/checkDuplicateEmail/', duplicateEmailCheckInputModel);
  }

  //Get the list of messages
  getMessagesList(iMessageInput: IMessageInput): Observable<OMessageOutput[]> {
    return this.postForEntityObject('common/GetMessage/', iMessageInput);
  }

  //Get the list of messages
  getAllMessageList(iMessageInput: MessageSearchInputModel): Observable<AllReceivedMessageInputModel[]> {
    return this.postForEntityObject('common/GetAllMessage/', iMessageInput);
  }

  getAllGroupMembers(messageGroupId: number, userId: number, exchangeId: number, propertyId: number): Observable<IMessageGroupMemberInputModel[]> {
    return this.GET('common/getAllGroupMembers/' + messageGroupId + "/" + userId + "/" + exchangeId + "/" + propertyId);
  }

  removeMemberFromGroup(messageGroupId: number, userId: number) {
    return this.GET('common/removeUserFromMessageGroup/' + messageGroupId + "/" + userId);
  }
  deleteGroup(messageGroupId: number) {
    return this.GET('common/deleteGroup/' + messageGroupId);
  }

  deletefilemanagement(filemanagementid: number) {
    let url = "common/deleteFilePageCategory?filecategoryid=" + filemanagementid;
    return this.get<IResponseModel>(url).pipe(map(response => {
      this.responseModel = response;
      return this.responseModel;
    }));
  }

  getUnreadNotificationCount(userId: number) {
    return this.GET('common/getUnreadNotificationCount?userId=' + userId);
  }

  followConversation(model: MessageFollowInputModel) {
    return this.postForEntityObject('common/followConversation/', model);
  }

  //Get the list of Users
  getAllUsersToMessage(iMessageInput: MessageSearchInputModel): Observable<AllReceivedMessageInputModel[]> {
    return this.postForEntityObject('common/GetAllUsersToMessage/', iMessageInput);
  }

  //save Messages
  SaveMessages(iMessageInput: IMessageInput) {
    let url = "/common/SaveMessage/";
    return this.postForEntityObject<IResponseModel>(url, iMessageInput).pipe(
      map(respondse => {
        this.responseModel = respondse;
        return this.responseModel;
      }));
  }

  //Get Message Group
  GetMessageGroup(iMessageInput: IMessageInput): Observable<IMessageGroupInputModel[]> {
    return this.postForEntityObject("/common/GetMessageGroup/", iMessageInput);
  }

  //save Message Group and Group Members
  SaveMessageGroupAndMembers(iMessageGroupData: MessageGroupCreateInputModel) {
    let url = "/common/SaveMessageGroupAndGroupMember/";
    return this.postForEntityObject<number>(url, iMessageGroupData).pipe(
      map(responds => {
        // this.responseModel = responds;
        return responds;
      }));
  }

  //Get User List
  GetMessageUserList(messageserUserListInputModels: MessageUserListInputModel): Observable<MessageUserListOutModel[]> {
    return this.postForEntityObject("/common/GetMessageUserList/", messageserUserListInputModels);
  }

  //Get User List
  GetPropertyContactPersonList(propertyId: number): Observable<MessageUserListOutModel[]> {
    return this.postForEntityObject('/common/GetPropertyContactPersonList/' + propertyId, '');
  }

  //Get Exchange User List
  GetExchangeUserList(exchangeId: number, propertyId: number): Observable<MessageUserListOutModel[]> {
    return this.postForEntityObject('/common/GetMessageExchangeUserList/' + exchangeId + "/" + propertyId, '');
  }

  //Get the Count of Unread messages
  GetMessageUnreadMessageCount(iMessageInput: IMessageInput): Observable<number> {
    return this.postForEntityObject('/common/GetMessageUnreadMessageCount/', iMessageInput);
  }

  //Get the Property list of Corrensonding Exchange
  GetGroupPropertyList(ExchangeId: number, UserId: number): Observable<IMessageGroupInputModel[]> {
    return this.postForEntityObject('/common/GetGroupPropertyList/' + ExchangeId + '/' + UserId, '');
  }

  //Get the Property list of Corrensonding Exchange
  GetAllReceivedMessageOfUser(UserId: number): Observable<AllReceivedMessageInputModel[]> {
    return this.postForEntityObject('/common/GetAllReceivedMessageOfUser/' + UserId, '');
  }

  //Get the Property list of Corrensonding Exchange
  supressMember(UserId: number, groupId: number) {
    return this.postForEntityObject<IResponseModel>('/common/SuppressMember/' + UserId + '/' + groupId, '').pipe(
      map(Responds => {
        this.responseModel = Responds;
        return this.responseModel;
      }));
  }

  //// Gets the Audit Trail Log List
  //GetAuditTrailLogList(objectId, objectTypeId) {
  //    return this.get('common/getAuditTrailLogList/' + objectId + "/" + objectTypeId);
  //}

  //// Gets the Audit Trail Detail List
  //GetAuditTrailDetailList(auditLogId: number) {
  //    return this.GET('common/getAuditTrailDetailList/' + auditLogId);
  //}

  GetAuditTrailLogList(objectId, objectTypeId): Observable<AuditTrailLogListModel[]> {
    return this.postForEntityObject("common/getAuditTrailLogList/" + objectId + "/" + objectTypeId, '');
  }

  GetMarkettingDashboardData(period: number, selectedAction: string, selectedUtmsource: string) {
    return this.GET("common/GetMarkettingDashboardData/" + period + "/" + selectedAction + "/" + encodeURIComponent(selectedUtmsource));
  }

  GetMarkettingDashboardData1(input:IMarketDataInputModel) {
    return this.post<any>("common/GetMarkettingDashboardData/", input).pipe(map(response => {
      return response;
    }));
  }

  GetUTMActionList() {
    return this.GET("common/GetUTMActionList");
  }

  GetMarkettingTableData(period: number, selectedAction: string, selectedUtmsource: string) {
    return this.GET("common/GetMarkettingTableData/" + period + "/" + selectedAction + "/" + selectedUtmsource);
  }

  GetAuditTrailDetailList(auditLogId): Observable<AuditTrailDetailModel[]> {
    return this.postForEntityObject("common/getAuditTrailDetailList/" + auditLogId, '');
  }

  GetFilterCount(type: number, userId: number) {
    return this.GET('common/FilterCount/' + type + '/' + userId);
  }

  AddLogs(input: any) {
    return this.post<any>("common/AddLogs/", input).pipe(map(response => {
      return response;
    }));
  }
    CheckAccess(inputmodel: any) {
    return this.postForEntityObject('common/CheckAccess/', inputmodel);
  }

  GetPrincipalForShareListingByAutoComplete(input: string) {
    return this.GET(encodeURI('common/principalForShareListingByAutoComplete/FilterCount/' + input));
  }

  saveGuarantor(input: any) {
    return this.postForEntityObject('common/createguarantor', input);
  }

  GetGuarantorDetails(guarantorId: number) {
    return this.GET('common/guarantordetails/' + guarantorId);
  }

  addFinancials(input: any) {
    return this.postForEntityObject('common/addFinancials', input);
  }

  // create new TYpe
  saveType(iTypeInput: ITypeInput) {

    let url = "/common/saveType/";
    return this.postForEntityObject<IResponseModel>(url, iTypeInput).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }


  GetFinancialsList(input: any) {
    return this.GET('common/financialslist/' + input);
  }

  // create new Subcategory
  saveTypeSubcategory(iTypeSubcategoryInput: ITypeSubcategoryInput) {

    let url = "/common/SaveTypeSubcategory/";
    return this.postForEntityObject<IResponseModel>(url, iTypeSubcategoryInput).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }

  // Gets the list of Property Types
  getTypeList() {
    return this.GET('common/Types');
  }
  deleteType(id: number, userId: number) {
    let url = "common/deleteType?id=" + id + "&userId=" + userId;
    return this.get<IResponseModel>(url).pipe(map(response => {
      this.responseModel = response;
      return this.responseModel;
    }));
  }
  deleteTypeSubcategory(id: number, userId: number) {
    let url = "common/deleteSubcategory?id=" + id + "&userId=" + userId;
    return this.get<IResponseModel>(url).pipe(map(response => {
      this.responseModel = response;
      return this.responseModel;
    }));
  }


  RemoveGuarantor(guarantorId: any, userId: number) {
    return this.get('common/removeguarantor?guarantorId=' + guarantorId + "&userId=" + userId);
  }

  GetFinancialsDetails(financialId: number) {
    return this.GET('common/financialsDetails/' + financialId);
  }

  RemoveFinancials(financialId: any) {
    return this.postForEntityObject('common/removeFinancialsDetails/' + financialId, '');
  }

  saveTenantEntity(input: any) {
    return this.postForEntityObject('common/createtenantentity', input);
  }

  saveNewsTickerDetail(input: NewsTickerDetailsModel) {
    return this.postForEntityObject('common/saveNewsTickerDetails', input);
  }

  GetTenantEntityDetails(TEId: number) {
    return this.GET('common/tenantEntitydetails/' + TEId);
  }

  RemoveTenantEntity(TEId: any) {
    return this.postForEntityObject('common/removeTenantEntity/' + TEId, '');
  }

  getSubcategoryList(typeId) {
    return this.post('common/subcategoryByTypeId/', typeId);
  }
  getSubcategoryListByTypeIds(typeId) {
    return this.post('common/subcategoryListByTypeId/', typeId);
  }

  saveTenant(input: any) {
    return this.postForEntityObject('common/saveTenant', input);
  }

  GetTenantDetails(tenantId: number) {
    return this.GET('common/tenantDetails/' + tenantId);
  }

  GetDealContactTypes() {
    return this.GET('common/dealcontacttype/');
  }

  RemoveTenant(tenantId: any, userId: number) {
    return this.get('common/RemoveTenant?tenantId=' + tenantId + "&userId=" + userId);
  }

  GetGuarantor() {
    return this.GET('common/getGuarantor/');
  }

  GetGuarantorMappedToEntity(entityId: number) {
    return this.GET('common/guarantorMappedToEntity/' + entityId);
  }

  MapGuarantorToEntity(input: any) {
    return this.postForEntityObject('common/mapGuarantorToEntity/', input);
  }

  GetGuarantorMappedToTenant(tenantId: number) {
    return this.GET('common/guarantorMappedToTenant/' + tenantId);
  }

  MapGuarantorToTenant(input: any) {
    return this.postForEntityObject('common/mapGuarantorToTenant/', input);
  }

  GetGuarantorMappedToTenantList(tenantId: number) {
    return this.GET('common/guarantorMappedToTenantList/' + tenantId);
  }

  RemoveGuarantorTenantMapping(mappingId: any) {
    return this.postForEntityObject('common/removeGuarantorTenantMapping/' + mappingId, '');
  }

  GetTenantMappedToGuarantorList(guarantorId: number) {
    return this.GET('common/tenantMappedToGuarantorList/' + guarantorId);
  }

  CheckTenantGuarantorMapping(guarantorId: number, tenantId: number) {
    return this.GET('common/CheckTenantGuarantorMapping/' + guarantorId + "/" + tenantId);
  }

  SaveExpenseCategory(input: any) {
    return this.postForEntityObject<IResponseModel>('common/SaveExpenseCategory/', input);
  }

  SaveMetatag(input: any) {
    return this.postForEntityObject<IResponseModel>('common/SaveMetatag/', input);
  }

  DeleteExpenseCategory(input: any, userId: number) {
    return this.delete<IResponseModel>('common/DeleteExpenseCategory/' + input + "/" + userId);
  }

  DeleteMetaTag(input: any, userId: number) {
    return this.delete<IResponseModel>('common/DeleteMetaTag/' + input + "/" + userId);
  }

  getFilePageManagement() {
    return this.GET('common/FilePageManagement');
  }

  getExpenseCategory() {
    return this.GET('common/ExpenseCategory/');
  }

  saveFileCategoryPageMapping(input: FileCategorySave){
    return this.postForEntityObject<IResponseModel>('common/FileCategoryPageMapping/', input);
  }

  saveHourLimit(input: IHourModel) {
    return this.postForEntityObject<IResponseModel>('common/SaveHourlyLimit/', input);
  }

  WriteLog(log: any) {
    try {
      return this.postForEntityObject('common/writeLog', log);
    }
    catch (ex) {
      return log;
    }
  }

  GetPropertyTypeWithCount(propertyType: any) {
    var result = '';
    if (propertyType) {
      var type = propertyType.split(',')
      var count = type.length - 1;
      result = type[0] + (count > 0 ? ', ' + count + '+' : '');
    }
    return result;
  }

  getSelectedComponent(url: any) {
    var type = 0;

    switch (url) {
      case '/comp-view': // comps
        type = 1
        break;
      case '/archive-view': // archive
        type = 2
        break;
      default:
        type = 0
        break;
    }

    return type
  }

  setDefaultGuarantor(tenantId: any, guarantorId: any) {
    return this.postForEntityObject('common/setDefaultGuarantorTenantMapping/' + tenantId + '/' + guarantorId, '');
  }

  YEARFRAC(start_date, end_date, basis) {

    // Credits: David A. Wheeler [http://www.dwheeler.com/]

    // Initialize parameters
    var basis = (typeof basis === 'undefined') ? 0 : basis;
    var sdate = moment(new Date(start_date));
    var edate = moment(new Date(end_date));

    // Return error if either date is invalid
    if (!sdate.isValid() || !edate.isValid()) return '#VALUE!';

    // Return error if basis is neither 0, 1, 2, 3, or 4
    if ([0, 1, 2, 3, 4].indexOf(basis) === -1) return '#NUM!';

    // Return zero if start_date and end_date are the same
    if (sdate === edate) return 0;

    // Swap dates if start_date is later than end_date
    if (sdate.diff(edate) > 0) {
      var edate = moment(new Date(start_date));
      var sdate = moment(new Date(end_date));
    }

    // Lookup years, months, and days
    var syear = sdate.year();
    var smonth = sdate.month();
    var sday = sdate.date();
    var eyear = edate.year();
    var emonth = edate.month();
    var eday = edate.date();

    switch (basis) {
      case 0:
        // US (NASD) 30/360
        // Note: if eday == 31, it stays 31 if sday < 30
        if (sday === 31 && eday === 31) {
          sday = 30;
          eday = 30;
        } else if (sday === 31) {
          sday = 30;
        } else if (sday === 30 && eday === 31) {
          eday = 30;
        } else if (smonth === 1 && emonth === 1 && sdate.daysInMonth() === sday && edate.daysInMonth() === eday) {
          sday = 30;
          eday = 30;
        } else if (smonth === 1 && sdate.daysInMonth() === sday) {
          sday = 30;
        }
        return ((eday + emonth * 30 + eyear * 360) - (sday + smonth * 30 + syear * 360)) / 360;
        break;

      case 1:
        // Actual/actual
        var feb29Between = function (date1, date2) {
          // Requires year2 == (year1 + 1) or year2 == year1
          // Returns TRUE if February 29 is between the two dates (date1 may be February 29), with two possibilities:
          // year1 is a leap year and date1 <= Februay 29 of year1
          // year2 is a leap year and date2 > Februay 29 of year2

          var mar1year1 = moment(new Date(date1.year(), 2, 1));
          if (moment([date1.year()]).isLeapYear() && date1.diff(mar1year1) < 0 && date2.diff(mar1year1) >= 0) {
            return true;
          }
          var mar1year2 = moment(new Date(date2.year(), 2, 1));
          if (moment([date2.year()]).isLeapYear() && date2.diff(mar1year2) >= 0 && date1.diff(mar1year2) < 0) {
            return true;
          }
          return false;
        };
        var ylength = 365;
        if (syear === eyear || ((syear + 1) === eyear) && ((smonth > emonth) || ((smonth === emonth) && (sday >= eday)))) {
          if (syear === eyear && moment([syear]).isLeapYear()) {
            ylength = 366;
          } else if (feb29Between(sdate, edate) || (emonth === 1 && eday === 29)) {
            ylength = 366;
          }
          return edate.diff(sdate, 'days') / ylength;
        } else {
          var years = (eyear - syear) + 1;
          var days = moment(new Date(eyear + 1, 0, 1)).diff(moment(new Date(syear, 0, 1)), 'days');
          var average = days / years;
          return edate.diff(sdate, 'days') / average;
        }
        break;

      case 2:
        // Actual/360
        return edate.diff(sdate, 'days') / 360;
        break;

      case 3:
        // Actual/365
        return edate.diff(sdate, 'days') / 365;
        break;

      case 4:
        // European 30/360
        if (sday === 31) sday = 30;
        if (eday === 31) eday = 30;
        // Remarkably, do NOT change February 28 or February 29 at ALL
        return ((eday + emonth * 30 + eyear * 360) - (sday + smonth * 30 + syear * 360)) / 360;
        break;
    }
  }

  decodereCaptchaToken(token: string) {
    let RecaptchaModel = { token: token }
    return this.post('common/decodereCaptchaToken', RecaptchaModel);
  }

  // Gets the Intercom config details
  getIntercomConfigDetails() {
    return this.get<IIntercomConfig>('common/IntercomConfigDetails');
  }

  subscribeActiveCampaign(postData: any) {
    return this.post('common/SubscribeActiveCampaign', postData);
  }

  SubscribeEmail(postData: any) {
    return this.post('common/SubscribeEmail', postData);
  }

  GetTenantList() {
    return this.GET('common/Tenants');
  }

  GetWatchListTenantList() {
    return this.GET('common/WatchListTenants');
  }

  GetPropertyByTenantId(tenantid: number, filtername: string) {
    return this.GET('common/Tenant/Property/' + tenantid + '/'+ filtername);
  }

  GetUsersLst() {
    return this.GET('common/Users');
  }

  GetProperties() {
    return this.GET('common/Properties');
  }

  GetPropertiesBySearch(propertyAuditLogFilter: IPropertyAuditLogFilter) {
    return this.postForEntityObject<IPropertyListOutputModel[]>('common/Property/Search/', propertyAuditLogFilter);
  } /*InterestedTenants*/

  GetTeanantBySearch(searchtext: string) {
    return this.GET('common/Tenants/Search/' + searchtext);
  }
  GetInterestedTeanantBySearch(searchtext: string) {
    return this.GET('common/InterestedTenants/' + searchtext);
  }
  GetGuarantorBySearch(searchtext: string) {
    return this.GET('common/GetGuarantorBySearch/' + searchtext);
  }
  GetAccounts(searchtext: string) {
    return this.GET('property/GetAccounts/' + searchtext);
  }
  GetInterestedStatesBySearch(searchtext: string) {
    return this.GET('common/InterestedStates/' + searchtext);
  }
  GetUserSearch(searchtext: string) {
    return this.GET('common/User/Search/' + searchtext);
  }

  GetPropertyTypes() {
    return this.GET('common/PropertyTypes');
  }

  GetSubcategories() {
    return this.GET('common/Subcategories');
  }
 
  GetInsights() {
    return this.get<IInsights[]>('common/Insights/');
  }

  getTenantsForUsers(userId: number, userGuid: string) {
    return this.GET('common/GetTenantsForUsers/' + userId + '/' + userGuid);
  }

  addNotificationToBeBrokers(userId: number, propertyId: number) {
    return this.post('common/addDashboardAccessNotification/' + userId + "/" + propertyId, '');
  }

  getPrincipalWithoutExchangeByAutoComplete(searchText:string) {
    return this.GET('common/GetPrincipalWithoutExchangeByAutoComplete/' + searchText);
  }

  getPrincipalListByEmailAutoComplete(searchText: string, userId: number) {
    return this.GET('common/GetPrincipalListByEmailAutoComplete/' + searchText + '/' + userId);
  }

  principalListByEmailAutoComplete(searchText: string, userId: number) {
    return this.GET('common/principalListByEmailAutoComplete/' + searchText + '/' + userId);
  }

}
